import { render, staticRenderFns } from "./BuyKit.vue?vue&type=template&id=9ca4910a"
import script from "./BuyKit.vue?vue&type=script&lang=js"
export * from "./BuyKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports